import { LoadingOverlay, AppShell, Flex } from '@mantine/core';

import { Outlet } from 'react-router';
import { Header } from '@widgets/header';
import { useDisclosure } from '@mantine/hooks';
import { useAuth } from '@entities/auth';

import classes from './layout.module.scss';
import { Navbar } from '@widgets/navbar';

export const Layout = () => {
  const [opened, { toggle }] = useDisclosure(true);

  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingOverlay visible={isLoading} />;
  }

  if (!isAuthenticated) {
    return <LoadingOverlay visible={isLoading} />;
  }

  return (
    <AppShell
      layout='alt'
      header={{
        height: 84,
      }}
      navbar={{
        width: 280,
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
    >
      <Header opened={opened} toggle={toggle} />

      <AppShell.Main pt='calc(84px + 1rem)' ml={{ base: 0, sm: '2.5rem' }}>
        <Flex className={classes.wrapper}>
          <Outlet />
        </Flex>
      </AppShell.Main>

      <Navbar opened={opened} toggle={toggle} />
    </AppShell>
  );
};
